import Vue from 'vue'

function initialNotifications() {
  return []
}

const state = Vue.observable({ notifications: initialNotifications() })

export const systemNotificationRepository = {
  state,
  list() {
    return state.notifications
  },
  markRead(id) {
    const item = state.notifications.find(notification => String(notification.id) === String(id))
    if (item) Vue.set(item, 'isRead', true)
    return item || null
  },
  reset() {
    state.notifications.splice(0, state.notifications.length, ...initialNotifications())
  },
}
